export default function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/~/react-transition-group/~/@babel/runtime/helpers/esm/inheritsLoose.js
// module id = 378
// module chunks = 121